// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/index.scss
// module id = 2
// module chunks = 0